const getBrowserTimezone = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export default getBrowserTimezone;
